import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { ThemeProvider, createTheme } from "@mui/material";

let ErrorBoundary = null;

// replace console.* for disable log on production
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};

  //Configuramos bugsnag únicamente para modo de producción
  Bugsnag.start({
    apiKey: process.env.REACT_APP_BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginReact()],
  });
  ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);
}

// Configuración de tipografía para los component
const theme = createTheme({
  typography: {
    fontFamily: [
      'Roboto',
      'sans-serif',
      'Montserrat',
    ].join(','),
  },});

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme} >
      {ErrorBoundary !== null ? (
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      ) : (
        <App />
      )}
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
